<template>
  <div>
    <div id="surveyCreatorContainerUser"></div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">Form Information</h4>
      <ValidationObserver ref="formBuilderForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="formName" placeholder="Name" label="Form Name"></fg-input>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">Cancel</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button
            type="info"
            link
            @click="createForm"
          >Create Form</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import Modal from "src/components/UIComponents/Modal.vue";

import Resource from "@/util/Api/resource.js";
const FormResource = new Resource("forms");

export default {
  name: "form-builder",
  components: {
    Modal
  },
  data() {
    return {
      modals: {
        classic: false
      },
      formName: "",
      formContent: ""
    };
  },

  mounted() {
    SurveyCreator.StylesManager.applyTheme("bootstrap");

    let options = {};

    let surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainerUser",
      options
    );

    surveyCreator.showToolbox = "right";
    surveyCreator.showPropertyGrid = "right";
    surveyCreator.rightContainerActiveItem("toolbox");

    surveyCreator.haveCommercialLicense = true;
    const vm = this;

    surveyCreator.saveSurveyFunc = function() {
      const formContent = JSON.parse(this.text);
      vm.openUpdateModal(formContent);
    };
  },

  methods: {
    showAlertMessage(message, type){
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    resetForm() {
      this.formName = "";
      this.$refs.formBuilderForm.reset();
    },
    handleCloseModal(){
      this.modals.classic = false;
      this.resetForm()
    },
    openUpdateModal(formContent){
      this.modals.classic = true;
      this.formContent = formContent;
    },
    async createForm() {
      let formData = {};
      formData.form_content = this.formContent;
      formData.name = this.formName;

      await FormResource.store(formData)
        .then(response => {
          this.$router.push({
            name: "FormBuilder",
          });
          this.showAlertMessage(response.message, "success")
        })
        .catch(error => {
          if (error.response.data.error) {
            this.$refs.formBuilderForm.setErrors(error.response.data.error.message);
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
